import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';

export const TokenSent: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.activation.prompt.title');
  return (
    <PageRootWrapper
      title={title}
      headerTitle={t('pages.activation.prompt.title')}
      breadcrumbItems={[{ label: t('pages.activation.prompt.title') }]}
      containerType="normal"
    >
      <p>{t('text.activation.prompt.attention')}</p>
      <p>{t('text.activation.prompt.request')}</p>
    </PageRootWrapper>
  );
};
